
import Repeat from "../../../assets/outline/Repeat.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RepeatIcon({ className, dataTestid = "RepeatIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Repeat data-testid={dataTestid} className={classes} {...rest} />
  );
}
